<div class="edit-details-page-wrapper">
  <div class="container landing-container">
    <form [formGroup]="formGroup">
      <div class="page-header">
        <h3 class="page-title">Edit Details</h3>
      </div>

      <div class="data-showcase-grid">
        <h4 class="grid-title">Personal Details</h4>
        <div class="profile-wrap">
          <img [src]="
            user.profilePictureUrl
              ? user.profilePictureUrl
              : './assets/images/profile-tab-view.svg'
          " style="border-radius: 50%" alt="Avatar" class="user-profile" />
          <!-- <app-button [btnText]="'Change Profile'" [btnTitle]="'Change Profile'"
                    [btnCss]="'btn btn-outline-primary btn-profile'" (onBtnClick)="openFileInput($event)"></app-button> -->
          <button class="btn btn-outline-primary" (click)="openFileInput()" title="Change Profile">
            Change Profile
          </button>
          <input type="file" #fileInput style="display: none" accept="image/*" (change)="onFileSelected($event)" />
          <!-- <app-input [inputType]="'file'" (change)="onFileSelected($event)" class="file-upload"></app-input> -->
        </div>
        <div class="row">
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="user.firstName" [fieldText]="'firstName'"
              [fControl]="formGroup.controls['FirstName']" [inputClass]="'form-control'"
              [inputPlaceholder]="'Enter First Name'" [inputLabel]="'First Name'" [labelClass]="'data-label'"
              (onTextChange)="onTextValueChange($event)" [maxLengthValidationMsg]="
              'First Name must be at most 25 characters long.'
            " [customErrorValidationMsg]="
              'First Name must contain only alphabets'
            " appAlphabetOnly (keydown.enter)="$event.preventDefault()"></app-input>
          </div>
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="user.lastName" [fieldText]="'lastName'"
              [fControl]="formGroup.controls['LastName']" [inputClass]="'form-control'"
              [inputPlaceholder]="'Enter Last Name'" [inputLabel]="'Last Name'" [labelClass]="'data-label'"
              (onTextChange)="onTextValueChange($event)" [maxLengthValidationMsg]="
              'Last Name must be at most 25 characters long.'
            " [customErrorValidationMsg]="'Last Name must contain only alphabets'" appAlphabetOnly
              (keydown.enter)="$event.preventDefault()"></app-input>
          </div>
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="user.email" [fieldText]="'email'"
              [fControl]="formGroup.controls['Email']" [inputClass]="'form-control'" [inputPlaceholder]="'Enter Email'"
              [inputLabel]="'Email'" [labelClass]="'data-label'" (onTextChange)="onTextValueChange($event)"
              [patternValidationMsg]="'Email is invalid'" [maxLengthValidationMsg]="
            'Email must be at most 50 characters long.'
          " (keydown.enter)="$event.preventDefault()"></app-input>
          </div>
        </div>
      </div>

      <div class="data-showcase-grid">
        <h4 class="grid-title">Address Details</h4>
        <div class="row">
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="user.address" [fieldText]="'address'"
              [fControl]="formGroup.controls['Address']" [inputPlaceholder]="'Enter Address'" [inputLabel]="'Address'"
              [labelClass]="'data-label'" [isRequired]="false" (onTextChange)="onTextValueChange($event)"
              (keydown.enter)="$event.preventDefault()" appNoSpecialCharacter [maxLengthValidationMsg]="
            'Address must be at most 255 characters long.'
          "></app-input>
          </div>
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="user.city" [fieldText]="'city'"
              [fControl]="formGroup.controls['City']" [inputClass]="'form-control'" [inputPlaceholder]="'Enter City'"
              [inputLabel]="'City'" [isRequired]="false" [labelClass]="'data-label'"
              (onTextChange)="onTextValueChange($event)"
              [maxLengthValidationMsg]="'City must be at most 30 characters long.'"
              (keydown.enter)="$event.preventDefault()" appAlphabetOnly></app-input>
          </div>
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="user.zip" [fieldText]="'zip'"
              [fControl]="formGroup.controls['Zip']" [inputClass]="'form-control'" [inputPlaceholder]="'Enter Zip'"
              [inputLabel]="'Zip'" [isRequired]="false" [labelClass]="'data-label'"
              (onTextChange)="onTextValueChange($event)" [maxLengthValidationMsg]="
            'Zip must be at most 15 characters long.'
          " [minLengthValidationMsg]="
          'Zip must be at least 5 characters long.'
        " [customErrorValidationMsg]="
        'Zip can contains only alphabets and digits'
      " (keydown.enter)="$event.preventDefault()"></app-input>
          </div>
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="user.mobileNumber" [fieldText]="'phone'"
              [fControl]="formGroup.controls['Phone']" [inputClass]="'form-control'"
              [inputPlaceholder]="'Enter Phone Number'" [inputLabel]="'Phone Number'" [isRequired]="false"
              [labelClass]="'data-label'" (onTextChange)="onTextValueChange($event)" [minLengthValidationMsg]="
            'Phone Number must be at least 7 digits long.'
          " [maxLengthValidationMsg]="
            'Phone Number must be at most 15 digits long.'
          " [customErrorValidationMsg]="'Phone Number contains only digits.'" appNumbersOnly
              (keydown.enter)="$event.preventDefault()"></app-input>
          </div>
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="" [fieldText]="'location'"
              [fControl]="formGroup.controls['Location']" [inputClass]="'form-control'"
              [inputPlaceholder]="'Enter Location'" [inputLabel]="'Location'" [isRequired]="false"
              [labelClass]="'data-label'" (onTextChange)="onTextValueChange($event)"
              (onInputClick)="openModal(setLocationComponent.setLocationTemplate);"
              (keydown.enter)="$event.preventDefault()"></app-input>
          </div>
        </div>
      </div>
      <div class="data-showcase-grid">
        <h4 class="grid-title">Social Media</h4>
        <div class="row">
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="user.instagramId" [fieldText]="'instagram'"
              [fControl]="formGroup.controls['Instagram']" [inputClass]="'form-control'"
              [inputPlaceholder]="'Enter Instagram ID'" [inputLabel]="'Instagram'" [labelClass]="'data-label'"
              [isRequired]="false" (onTextChange)="onTextValueChange($event)"
              [customErrorValidationMsg]="'Invalid Instagram ID'" (keydown.enter)="$event.preventDefault()"
              [maxLengthValidationMsg]="'Instagram ID must be at most 30 characters long.'
            "></app-input>
          </div>
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="user.tikTokId" [fieldText]="'tiktok'"
              [fControl]="formGroup.controls['TikTok']" [inputClass]="'form-control'"
              [inputPlaceholder]="'Enter TikTok ID'" [inputLabel]="'TikTok'" [isRequired]="false"
              [labelClass]="'data-label'" (onTextChange)="onTextValueChange($event)"
              [customErrorValidationMsg]="'Invalid TikTok ID'" (keydown.enter)="$event.preventDefault()"
              [maxLengthValidationMsg]="'Tiktok ID must be at most 24 characters long.'
            "></app-input>
          </div>
          <div class="col-sm-6">
            <app-input [inputType]="'text'" [fieldValue]="user.faceBookId" [fieldText]="'facebook'"
              [fControl]="formGroup.controls['FaceBook']" [inputClass]="'form-control'"
              [inputPlaceholder]="'Enter Facebook ID'" [inputLabel]="'Facebook'" [isRequired]="false"
              [labelClass]="'data-label'" (onTextChange)="onTextValueChange($event)"
              [customErrorValidationMsg]="'Invalid Facebook ID'" (keydown.enter)="$event.preventDefault()"
              [minLengthValidationMsg]="'Facebook ID must be at least 5 characters long.'" [maxLengthValidationMsg]="'Facebook ID must be at most 15 characters long.'
            "></app-input>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="bottom-action bottom-action-onb-cst">
    <div class="bottom-action-inner">
      <div class="btn-grps">
        <app-button [btnText]="'Save Details'" [btnTitle]="'Save Details'" [btnCss]="'btn btn-primary'"
          (onBtnClick)="saveDetails()" [isDisable]="isDisableSaveBtn"></app-button>
      </div>
    </div>
  </div>
</div>
<app-set-location-modal #setLocationModal (locationEmit)="locationEmit($event)"></app-set-location-modal>
